var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectors({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5934_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 9L9 12.75L7.875 13.875C7.63025 14.1278 7.33763 14.3294 7.01419 14.468C6.69075 14.6066 6.34296 14.6795 5.99108 14.6824C5.63921 14.6852 5.29028 14.618 4.96463 14.4847C4.63898 14.3513 4.34313 14.1545 4.09431 13.9057C3.84548 13.6569 3.64867 13.361 3.51533 13.0354C3.38199 12.7097 3.31479 12.3608 3.31764 12.0089C3.3205 11.657 3.39336 11.3092 3.53197 10.9858C3.67058 10.6624 3.87217 10.3698 4.125 10.125L5.25 9Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9L9 5.25L10.125 4.125C10.3698 3.87217 10.6624 3.67057 10.9858 3.53196C11.3092 3.39335 11.657 3.32049 12.0089 3.31764C12.3608 3.31478 12.7097 3.38198 13.0354 3.51532C13.361 3.64866 13.6569 3.84548 13.9057 4.0943C14.1545 4.34313 14.3513 4.63898 14.4847 4.96463C14.618 5.29028 14.6852 5.6392 14.6824 5.99108C14.6795 6.34296 14.6066 6.69075 14.468 7.01419C14.3294 7.33763 14.1278 7.63025 13.875 7.875L12.75 9Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 15.75L4.125 13.875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.875 4.125L15.75 2.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.25L6 9.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 10.5L8.25 12",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5934_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectors);
export default __webpack_public_path__ + "static/media/connectors.cb57bda1f00b3db047f3bfd61fac6467.svg";
export { ForwardRef as ReactComponent };